export default __webpack_public_path__ + "static/media/035-tortoise.45b0fc3b.png";